import { CustomFieldsModel } from '@w3lcome/types';
import { ReqQueryType } from './types/ReqQuery';
import api from './base';

class CustomFields {
  private fieldsPath = '/custom-fields';
  private fieldsValuePath = 'custom-field-values';

  getFieldsValues = async (customFieldId: string) => {
    const { data } = await api.get(`${this.fieldsValuePath}?customFieldId=${customFieldId}`);

    return data;
  };

  getFieldsValuesByVisitId = async (visitId: string, params?: ReqQueryType<CustomFieldsModel>) => {
    const { data } = await api.get(`${this.fieldsValuePath}?visitId=${visitId}`, {
      params,
    });

    return data;
  };

  getFieldsValuesByMeetingId = async (
    meetingId: string,
    params?: ReqQueryType<CustomFieldsModel>
  ) => {
    const { data } = await api.get(`${this.fieldsValuePath}?meetingId=${meetingId}`, {
      params,
    });

    return data;
  };
}

export default new CustomFields();
